import { createStyles, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
    },
    headerButton: {
      marginRight: theme.spacing(1),
    },
    alignedRow: {
      '& > div[role="gridcell"]': {
        lineHeight: '36px',
      },
    },
  });

export const useStyles = makeStyles(styles);
